'use strict';

(function ($) {
  let scrollPosition = 0;

  // 바디 스크롤 막는 함수
  function preventBodyScroll(e) {
    // 팝업 내부(.laypop-cont)가 아니면 스크롤 막기
    if (!e.target.closest('.laypop-cont')) {
      e.preventDefault();
    }
  }

  // --- 전역 노출: HTML onclick 없이도 호출 가능하도록 ---
  window.laypopOpen = function (target) {
    scrollPosition = window.pageYOffset;
      
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
    document.body.style.touchAction = 'none';
    
    $(target).show();
    
    document.body.addEventListener('touchstart', preventBodyScroll, { passive: false });
    document.body.addEventListener('touchmove', preventBodyScroll, { passive: false });
    
    return false;
  };

  window.laypopClose = function (popupId) {
    document.body.removeEventListener('touchstart', preventBodyScroll);
    document.body.removeEventListener('touchmove', preventBodyScroll);
    
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.touchAction = '';
    
    // $('.laypop').hide(); 모든 팝업(.laypop ) 닫기
    
    if (popupId) {
      $('#' + popupId).hide();
    } else {
      $('.laypop').hide();
    }
    return false;
  };

  $(function () {
    
    // notice / 유의사항 토글
    $(document).on('click', '.content-notice .btn-fold', function () {
      const btn = $(this);
      const notice = $('.content-notice');
      const isExpanded = notice.hasClass('on');

      if (isExpanded) {
        notice.removeClass('on');
        btn.attr('aria-expanded', 'false');
      } else {
        notice.addClass('on');
        btn.attr('aria-expanded', 'true');
      }
    });

    // 팝업 열기: data-popup-target="#popup1"
    $(document).on('click', '[data-popup-target]', function (e) {
      e.preventDefault();
      const sel = $(this).data('popup-target');
      if (sel) window.laypopOpen(sel);
    });

    // 팝업 닫기: data-popup-close="popup1"
    $(document).on('click', '[data-popup-close]', function (e) {
      e.preventDefault();
      const id = $(this).attr('data-popup-close');
      if (id) window.laypopClose(id);
    });
    
    // # 검색 시 삭제 아이콘 노출
    const inputs = document.querySelectorAll(".inp-search");
    inputs.forEach(input => {
      const wrapper = input.closest(".item-tf");
      const btnDel = wrapper?.querySelector(".btn-del");

      input.addEventListener("input", () => {
        const hasValue = input.value.trim().length > 0;
        if (btnDel) btnDel.style.display = hasValue ? "block" : "none";
      });

      const hasValue = input.value.trim().length > 0;
      if (btnDel) btnDel.style.display = hasValue ? "block" : "none";

      btnDel?.addEventListener("click", () => {
        input.value = "";
        btnDel.style.display = "none";
        input.focus();
      });
    });
    
  });
})(jQuery);
